export default __webpack_public_path__ + "static/media/custodyRequest.8007f139.png";